// extracted by mini-css-extract-plugin
export default {"Button":"Button_Button__9u55M","Neutral":"Button_Neutral__PVZPF","Danger":"Button_Danger__a9LAi","Success":"Button_Success__pSv4I"};